// Tag update type constants
export const TAG_UPDATE_TYPE = {
  TAG: "tag",
  ENTITY_TAG: "entityTag",
};
